module.exports = __webpack_public_path__ + "img/80.ab8f8f8a.jpg";